import styled from 'styled-components'

export const G = styled.g``
